// extracted by mini-css-extract-plugin
module.exports = {"centered":"Unauthenticated_centered__89fBA","note":"Unauthenticated_note__IN6pD","signin":"Unauthenticated_signin__2yxPk","error":"Unauthenticated_error__1x0r5"};